<!--
 * @Author: zl
 * @Date: 2022-03-29 17:21:58
 * @LastEditTime: 2022-04-25 16:59:33
 * @LastEditors: zl
 * @Description: 三方巡查查看
-->
<template>
	<el-dialog :title="dialogObj.title"
			   :visible.sync="dialogObj.show"
			   width="1000px"
			   center
			   top="8vh"
			   lock-scroll
			   :close-on-click-modal="false"
			   custom-class="reset-dialog-height"
			   @close="dialogClose">
		<template v-if="!['6', '7'].includes(this.currentRow.moduleType)">
			<h2 class="text-center mb30">{{ this.headerTitle }}</h2>
			<el-row class="dialogForm">
				<el-col :span="8"
						:offset="15"
						class="mb10">
					巡查编号：{{ patrolForm.patrolNo }}
				</el-col>
				<el-col :span="22"
						:offset="1">
					<el-col :span="24"
							class="col-style">
						<el-col :span="5">工程项目名称</el-col>
						<el-col :span="19"
								class="borderLeft">{{ patrolForm.projectName }}</el-col>
					</el-col>
					<el-col :span="24"
							class="col-style">
						<el-col :span="5">标段名称</el-col>
						<el-col :span="19"
								class="borderLeft">
							{{ patrolForm.packName || '无' }}
						</el-col>
					</el-col>
					<el-col :span="24"
							class="col-style">
						<el-col :span="5">建设单位</el-col>
						<el-col :span="19"
								class="borderLeft">
							{{ patrolForm.jsTenantName }}
						</el-col>
					</el-col>
					<el-col :span="24"
							class="col-style">
						<el-col :span="5">施工单位</el-col>
						<el-col :span="19"
								class="borderLeft">
							{{ patrolForm.sgTenantName || '无' }}
						</el-col>
					</el-col>
					<el-col :span="24"
							class="col-style">
						<el-col :span="5">监理单位</el-col>
						<el-col :span="19"
								class="borderLeft">
							{{ patrolForm.jlTenantName || '无' }}
						</el-col>
					</el-col>
					<el-col :span="24"
							class="col-style">
						<el-col :span="5">巡查单位</el-col>
						<el-col :span="19"
								class="borderLeft">
							{{ patrolForm.xcTenantName || '无' }}
						</el-col>
					</el-col>
					<el-col :span="24"
							class="col-style">
						<el-col :span="5">
							{{ patrolForm.moduleType == '2' ? '编制单位' : '其他单位' }}
						</el-col>
						<el-col :span="19"
								class="borderLeft">
							{{ patrolForm.otherUnit || '无' }}
						</el-col>
					</el-col>
					<el-col :span="24"
							class="col-style">
						<el-col :span="5">{{ moduleTypeName }}</el-col>
						<el-col :span="19"
								class="borderLeft">
							{{ patrolForm.sname }}
						</el-col>
					</el-col>
					<el-col :span="24"
							class="col-style"
							v-if="patrolForm.moduleType != '8'">
						<el-col :span="5">巡查类型</el-col>
						<el-col :span="19"
								class="borderLeft">
							{{ patrolForm.patrolTypeName }}
						</el-col>
					</el-col>
					<template v-if="patrolForm.moduleType == '8'">
						<el-col :span="24"
								class="col-style">
							<el-col :span="5">处罚单签发单位</el-col>
							<el-col :span="19"
									class="borderLeft">
								<span v-if="patrolForm.auditPenaltySheet">
									{{ patrolForm.auditPenaltySheet.issuUnit }}
								</span>
							</el-col>
						</el-col>
						<el-col :span="24"
								class="col-style">
							<el-col :span="5">受罚单位</el-col>
							<el-col :span="19"
									class="borderLeft">
								<span v-if="patrolForm.auditPenaltySheet">
									{{ patrolForm.auditPenaltySheet.punishedUnit }}
								</span>
							</el-col>
						</el-col>
						<el-col :span="24"
								class="col-style">
							<el-col :span="5">处罚事由</el-col>
							<el-col :span="19"
									class="borderLeft">
								<div class="min200"
									 v-if="patrolForm.auditPenaltySheet">
									{{ patrolForm.auditPenaltySheet.matter }}
								</div>
							</el-col>
						</el-col>
						<el-col :span="24"
								class="col-style">
							<el-col :span="5">处罚金额（元）</el-col>
							<el-col :span="19"
									class="borderLeft">
								<span v-if="patrolForm.auditPenaltySheet">
									{{ patrolForm.auditPenaltySheet.price }}
								</span>
							</el-col>
						</el-col>
					</template>
					<template v-if="patrolForm.moduleType != '2'">
						<el-col :span="24"
								class="col-style">
							<el-col :span="5">{{ timeName }}</el-col>
							<el-col :span="19"
									class="borderLeft">
								<span v-if="!!patrolForm.patrolDate">
									{{ patrolForm.patrolDate.substr(0, 11) }}
								</span>
							</el-col>
						</el-col>
						<template v-if="patrolForm.moduleType == '4'">
							<el-col :span="24"
									class="col-style">
								<el-col :span="5">巡查范围</el-col>
								<el-col :span="19"
										class="borderLeft">
									{{ patrolForm.auditQualitySafety.patrolScope }}
								</el-col>
							</el-col>
							<el-col :span="24"
									class="col-style">
								<el-col :span="5">形象进度</el-col>
								<el-col :span="19"
										class="borderLeft">
									{{ patrolForm.auditQualitySafety.scheduleRemark }}
								</el-col>
							</el-col>
							<el-col :span="24"
									class="col-style">
								<el-col :span="5">上次巡查问题整改情况</el-col>
								<el-col :span="19"
										class="borderLeft">
									{{ patrolForm.auditQualitySafety.rectification }}
								</el-col>
							</el-col>
						</template>
						<el-col :span="24"
								class="col-style">
							<el-col :span="5">{{ contentName }}</el-col>
							<el-col :span="19"
									class="borderLeft">
								<div class="quill-editor editor min200 w100">
									<div class="ql-container">
										<div class="ql-editor">
											<div class="content"
												 v-html="patrolForm.content"></div>
										</div>
									</div>
								</div>
							</el-col>
						</el-col>
					</template>
					<template v-else>
						<template v-for="(item, index) in patrolForm.auditMonthlyInspections">
							<el-col :span="24"
									:key="index + 'auditMonthlyInspections'"
									class="col-style">
								<el-col :span="5">检查项</el-col>
								<el-col :span="19"
										class="cycle-box">
									<el-col :span="24">
										<el-col :span="5">检查日期</el-col>
										<el-col :span="7">
											<span>
												{{ !!item.patrolDate ? item.patrolDate.substr(0, 11) : '' }}
											</span>
										</el-col>
										<el-col :span="5">检查内容</el-col>
										<el-col :span="7">
											{{ item.checkContentName }}
										</el-col>
									</el-col>
									<el-col :span="24"
											class="flex">
										<el-col :span="5">检查要点</el-col>
										<el-col :span="19">
											<div class="min200">{{ item.content }}</div>
										</el-col>
									</el-col>
								</el-col>
							</el-col>
						</template>
						<el-col :span="24"
								class="col-style"
								v-if="patrolForm.moduleType == '2'">
							<el-col :span="5">备注</el-col>
							<el-col :span="19"
									class="borderLeft">
								<div class="min200">
									{{ patrolForm.remark }}
								</div>
							</el-col>
						</el-col>
					</template>
					<template v-if="patrolForm.moduleType == '4'">
						<el-col :span="24"
								class="col-style">
							<el-col :span="5">评分</el-col>
							<el-col :span="19"
									class="borderLeft padding0">
								<el-col :span="24"
										class="custom-box">
									<template v-for="item in scoreArr">
										<el-col :span="['101006', '101007'].includes(item.id) ? 2 : 4"
												:key="item.id + '1'">
											{{ item.sname }}
										</el-col>
									</template>
								</el-col>
								<el-col :span="24"
										class="custom-box">
									<template v-for="item in scoreArr">
										<el-col :span="['101006', '101007'].includes(item.id) ? 2 : 4"
												:key="item.id + '2'">
											{{ patrolForm.auditQualitySafety[item.field] }}
										</el-col>
									</template>
								</el-col>
							</el-col>
						</el-col>
						<el-col :span="24"
								class="col-style">
							<el-col :span="5">合计</el-col>
							<el-col :span="19"
									class="borderLeft">
								{{ sumTotal }}
							</el-col>
						</el-col>
						<el-col :span="24"
								class="col-style">
							<el-col :span="5">评价等级</el-col>
							<el-col :span="19"
									class="borderLeft">
								{{ patrolForm.auditQualitySafety.evaluationGrade }}
							</el-col>
						</el-col>
					</template>
					<el-col :span="24"
							class="col-style">
						<el-col :span="5">上传附件</el-col>
						<el-col :span="19"
								class="borderLeft">
							<myUpload listType="list"
									  v-if="dialogObj.show"
									  ref="patrolUpload"
									  tableName="audit_tripartite_inspection"
									  assortment="test2"
									  width="auto"
									  height="auto"
									  :aid="patrolForm.id"
									  mode="view"
									  class="w100"></myUpload>
						</el-col>
					</el-col>
				</el-col>
			</el-row>
		</template>
		<template v-else>
			<el-collapse v-model="activeName"
						 class="custom-collapse">
				<el-collapse-item title="#1   意见书/报告基本信息"
								  name="1">
					<el-form size="small"
							 label-width="160px"
							 class="custom-bottom">
						<el-row :gutter="10">
							<el-col :span="24">
								<el-form-item label="项目名称：">
									{{ dialogObj.obj.projectName }}
								</el-form-item>
							</el-col>
							<el-col :span="24">
								<el-form-item label="申报维度：">
									{{ dialogObj.obj.packId ? '标段' : '项目' }}
								</el-form-item>
							</el-col>
							<el-col :span="24">
								<el-form-item label="标段名称：">
									{{ dialogObj.obj.packName }}
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="回复类型：">
									<span>{{ dialogObj.obj.replyType }}</span>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item :label="dialogObj.obj.replyType + '名称：'">
									{{ dialogObj.obj.sname }}
								</el-form-item>
							</el-col>
							<el-col :span="24">
								<el-form-item label="巡查日期：">
									{{ dialogObj.obj.patrolDate }}
								</el-form-item>
							</el-col>
							<el-col :span="24">
								<el-form-item :label="dialogObj.obj.replyType + '附件：'">
									<span v-for="item in dialogObj.obj.sysFileVos"
										  :key="item.id + 'moduleType'">
										<FileName :fileName="item.fileName"
												  :filePath="item.filePath"
												  :fileSize="item.fileSize"></FileName>
									</span>
								</el-form-item>
							</el-col>
							<el-col :span="24">
								<el-form-item label="创建人：">
									{{ dialogObj.obj.createUserName }}
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="创建日期：">
									{{ dialogObj.obj.createDate }}
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="创建单位：">
									{{ dialogObj.obj.tenantName }}
								</el-form-item>
							</el-col>
						</el-row>
					</el-form>
				</el-collapse-item>
				<el-collapse-item title="#2   回复操作日志"
								  name="2">
					<vxe-table align="center"
							   auto-resize
							   border
							   :data="dialogObj.data"
							   highlight-current-row
							   highlight-hover-row
							   show-overflow="tooltip"
							   show-header-overflow="tooltip">
						<vxe-column field="content"
									title="回复内容"></vxe-column>
						<vxe-column field="sysFileVos"
									title="回复附件">
							<template #default="{ row }">
								<div style="overflow-x:auto">
									<span v-for="item in row.sysFileVos"
										  :key="item.id">
										<FileName :fileName="item.fileName"
												  :filePath="item.filePath"
												  :fileSize="item.fileSize"></FileName>
									</span>
								</div>
							</template>
						</vxe-column>
						<vxe-column field="replyUserName"
									title="回复操作人"></vxe-column>
						<vxe-column field="replyTenantName"
									title="回复操作单位">
							<template #default="{ row }">
								<el-tooltip effect="dark"
											:content="row.replyTenantName"
											placement="top"
											:disabled="row.replyTenantName.length < 11">
									<span class="vxe-cell--label">{{ row.replyTenantName }}</span>
								</el-tooltip>
							</template>
						</vxe-column>
						<vxe-column field="replyDate"
									title="回复日期"></vxe-column>
					</vxe-table>
				</el-collapse-item>
			</el-collapse>
		</template>
	</el-dialog>
</template>

<script>
import * as API from '@/api/Patrols/PatrolsIndex'
import FileName from '@/components/file/fileName'
export default {
	name: 'PatrolsDataIndex',
	props: {
		currentRow: {
			type: Object,
			default: () => {
				return {}
			},
		},
	},
	components: { FileName },
	data() {
		return {
			dialogObj: {
				show: false,
				title: '',
				data: [],
				obj: {},
			},
			activeName: ['1', '2'],
			headerTitle: '',
			moduleTypeName: '',
			timeName: '',
			contentName: '',
			patrolForm: {},
		}
	},
	created() {
		if (['6', '7'].includes(this.currentRow.moduleType)) {
			this.dialogObj.title = '回复说明'
			// 获取回复单内容
			this.getReportMsg()
			// 获取回复操作日志
			this.getLogList()
		} else {
			this.dialogObj.title = '查看' + this.currentRow.moduleTypeName
			// 处理title
			this.handlerTitle()
			// 查看时获取回显信息
			this.checkProjectPackDetail()
		}
	},
	methods: {
		// 获取回复单内容
		getReportMsg() {
			API.selTripartiteInspectionBaseInfo({
				baseId: this.currentRow.baseId,
			}).then((res) => {
				this.dialogObj.obj = res.data
			})
		},

		// 获取回复操作日志
		getLogList() {
			API.selReplyOperateDetailInfo({
				baseId: this.currentRow.baseId,
			}).then((res) => {
				this.dialogObj.data = res.data
			})
		},

		// 查看时获取回显信息
		checkProjectPackDetail() {
			API.checkProjectPackDetail({
				id: this.currentRow.id,
			}).then((res) => {
				this.patrolForm = this.$utils.clone(res.data, true)
			})
		},

		// 弹窗关闭
		dialogClose() {
			this.dialogObj.show = false
			this.$emit('sendClose', false)
		},

		// 处理title
		handlerTitle() {
			let type = this.currentRow.moduleType
			let title,
				typeName,
				time,
				content = ''
			switch (type) {
				case '1':
					title = '第三方质量安全巡查交底表'
					typeName = '安全巡查交底表名称'
					time = '交底日期'
					content = '交底内容'
					break
				case '2':
					title = '月度巡查计划表'
					typeName = '巡查计划表名称'
					time = '检查日期'
					content = '检查要点'
					break
				case '3':
					title = '第三方质量安全巡查意见书'
					typeName = '巡查意见书名称'
					time = '巡查日期'
					content = '巡查意见'
					break
				case '4':
					title = '第三方质量安全巡查报告'
					typeName = '工程巡查报告名称'
					time = '巡查日期'
					content = '巡查意见'
					break
				case '5':
					title = '第三方质量安全巡查月报'
					typeName = '工程巡查月报名称'
					time = '巡查日期'
					content = '报告内容'
					break
				case '8':
					title = '工程巡查处罚单'
					typeName = '处罚单名称'
					time = '处罚日期'
					content = '处罚意见'
					break
			}
			this.$set(this, 'headerTitle', title)
			this.$set(this, 'moduleTypeName', typeName)
			this.$set(this, 'timeName', time)
			this.$set(this, 'contentName', content)
		},
	},
	computed: {
		// 表单类型
		formTypeList() {
			let arr = [
				{ id: '1', sname: '安全巡查交底表' },
				{ id: '2', sname: '月度巡查计划表' },
				{ id: '3', sname: '工程巡查意见书' },
				{ id: '4', sname: '工程巡查报告' },
				{ id: '5', sname: '工程巡查报告单' },
				{ id: '6', sname: '回复单' },
			]
			return arr
		},

		// 评分列表
		scoreArr() {
			let arr = [
				{ sname: '市场行为', id: '101001', field: 'marketBehavior' },
				{
					sname: '工程质量',
					id: '101002',
					field: 'constructionQuality',
				},
				{ sname: '安全生产', id: '101003', field: 'safeProduction' },
				{ sname: '扬尘防治', id: '101004', field: 'dustControl' },
				{ sname: '专户管理', id: '101005', field: 'specialManage' },
				{ sname: '加分项', id: '101006', field: 'bonusItem' },
				{ sname: '扣分项', id: '101007', field: 'deductionItem' },
			]
			return arr
		},

		sumTotal() {
			let total = 0
			this.scoreArr.forEach((item) => {
				let num =
					parseFloat(
						this.patrolForm.auditQualitySafety[item.field]
					) || 0
				if (item.field != 'deductionItem') {
					total += num
				} else {
					total -= num
				}
			})
			return total
		},
	},
}
</script>
<style lang='less' scoped>
.dialogForm {
	.el-col-5 {
		justify-content: flex-end;
	}
	.col-style {
		display: flex;
		align-items: center;
		border: 1px solid #eee;
		border-collapse: collapse;
		.el-col {
			padding: 10px 15px;
		}
	}
	.el-col-2,
	.el-col-4,
	.el-col-5,
	.el-col-7,
	.el-col-19 {
		min-height: 55px;
		display: flex;
		align-items: center;
		.el-form-item {
			margin-bottom: 0px;
			width: 100%;
		}
	}
	.el-col-22 {
		border: 1px solid #eee;
		border-collapse: collapse;
	}
	.borderLeft {
		border-left: 2px solid #eee;
	}
	.red {
		color: red;
		margin-right: 5px;
	}
	/deep/ .editor {
		img {
			width: 100%;
		}
	}
	.min200 {
		min-height: 150px;
	}
	.el-form-item {
		margin-bottom: 0px !important;
	}
	.cycle-box {
		display: block;
		padding: 0 !important;
		border-left: 2px solid #eee;
		.el-col-24 {
			padding: 0 !important;
			border: none !important;
		}
		.el-col {
			border: 1px solid #eee;
		}
	}
	.padding0 {
		padding: 0 !important;
		display: block;
		.custom-box {
			height: 100%;
			padding: 0 !important;
			display: flex;
		}
		.custom-box > .el-col {
			padding: 10px !important;
			text-align: center;
			height: initial;
			justify-content: center;
		}
		.el-col-2 {
			width: 12.5% !important;
			border-left: 2px solid #eee;
		}
		.el-col-4 {
			width: 15% !important;
		}
		.el-col-4 + .el-col-4 {
			border-left: 2px solid #eee;
		}
		.el-col-24 + .el-col-24 {
			border-top: 2px solid #eee;
		}
	}
}
.custom-bottom {
	.el-form-item {
		margin-bottom: 0px !important;
	}
}
</style>